// Store correspondence. BuySaito already emails the team when issuance is short.
// These messages are the notices Store sends when a buyer asks to be told
// once that order can finish.

var SAITO_NOTICE_TO = 'buysaito@saito.tech';
var SAITO_NOTICE_CC = 'richard@saito.tech';
var SAITO_NOTICE_FROM = 'Saito Store <info@saito.tech>';
function insufficientFundsFollowupText() {
  var details = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var email = String(details.email || '').trim();
  var title = String(details.title || 'Store item').trim();
  var payment = String(details.payment || '').trim();
  var nftId = String(details.nftId || '').trim();
  var publicKey = String(details.publicKey || '').trim();
  var reservationId = String(details.reservationId || '').trim();
  return ['A buyer asked to be emailed when their Store order can be completed.', '', 'Their crypto payment is already recorded. The purchase stays in the BuySaito queue and completes on its own once the server has enough SAITO to issue.', '', "Buyer email: ".concat(email), "Item: ".concat(title), "Payment: ".concat(payment || 'unavailable'), "NFT: ".concat(nftId || 'unavailable'), "Buyer public key: ".concat(publicKey || 'unavailable'), "Reservation: ".concat(reservationId || 'unavailable'), '', 'Please contact the buyer at this address when the order completes.'].join('\n');
}
function sendInsufficientFundsFollowup(app) {
  var _app$connection;
  var details = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var email = String(details.email || '').trim();
  if (!(app !== null && app !== void 0 && (_app$connection = app.connection) !== null && _app$connection !== void 0 && _app$connection.emit) || !email) {
    return false;
  }
  app.connection.emit('mailrelay-send-email', {
    to: SAITO_NOTICE_TO,
    cc: [SAITO_NOTICE_CC, email].join(', '),
    from: SAITO_NOTICE_FROM,
    subject: "Store order waiting on SAITO \u2014 ".concat(String(details.title || 'Store item').trim()),
    text: insufficientFundsFollowupText(details),
    ishtml: false
  });
  return true;
}
module.exports = {
  SAITO_NOTICE_TO: SAITO_NOTICE_TO,
  SAITO_NOTICE_CC: SAITO_NOTICE_CC,
  SAITO_NOTICE_FROM: SAITO_NOTICE_FROM,
  insufficientFundsFollowupText: insufficientFundsFollowupText,
  sendInsufficientFundsFollowup: sendInsufficientFundsFollowup
};